import React from 'react'

const DropdownIcon14pxSvg = (props) => {
    return (
        <svg 
        {...props}
        width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="vuesax/bold/arrow-down">
                <g id="arrow-down">
                   <path d="M10.5 5.25L7 1.75L3.5 5.25H10.5ZM10.5 8.75L7 12.25L3.5 8.75H10.5Z" fill="#EAB308"/>
                </g>
            </g>
        </svg>

    )
}

export default DropdownIcon14pxSvg